import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomDelByNote, FullTable, PriceRow, TypeRow } from 'components';
import { invoiceTxnActions, httpRequestsOnSuccessActions, claimPaymentActions } from 'store';
import { FindLoad, FindSuccessItem, useModal } from 'utils';
import { invoiceTxnTableHead, invoiceTxnTableBody, INVOICE_TXN_LOAD_TYPE } from './constants';
import { useLocation } from 'react-router-dom';

const VOID_TYPE = 'VOID_INVOICE_TXN';
const CREATE_TYPE = 'CREATE_INVOICE_TXN';

export const InvoiceTransactions = () => {
    const dispatch = useDispatch();
    const invoiceTxns = useSelector((state) => state.invoiceTxn.invoiceTxns);
    const invoiceById = useSelector((state) => state.invoice.invoiceById);
    const createSuccess = FindSuccessItem(CREATE_TYPE);
    const loadVoid = FindLoad(VOID_TYPE);
    const location = useLocation();
    const info = location?.state;
    const [selectedId, setSelectedId] = useState(null);
    const { open, close } = useModal();

    const requestParams = () => {
        const params = {};
        info?.typeFilter ? (params.type = info.typeFilter) : delete params.typeFilter;
        return params;
    }
    const fetchTxns = () => {
        if (invoiceById?.id) {
            dispatch(invoiceTxnActions.getInvoiceTxns(invoiceById.id,  requestParams()));
        }
    };

    useEffect(() => {
        fetchTxns();
    }, [invoiceById?.id, info]);

    useEffect(() => {
        if (createSuccess) {
            fetchTxns();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(CREATE_TYPE));
        }
    }, [createSuccess]);

    const handleVoid = (txn) => {
        setSelectedId(txn?.id);

        open(
            <CustomDelByNote
                info="Void Transaction?"
                text="Voiding a transaction will cancel its financial impact and create an audit record. This action cannot be undone."
                handleDel={(closingComment) => {
                    dispatch(
                        invoiceTxnActions.voidInvoiceTxn(txn?.id, { voidReason: closingComment || null }, invoiceById.id, requestParams())
                    );
                }}
                body={
                    <div className="transaction-void-info">
                        <div>
                            <p>Transaction ID:</p>
                            <span>{txn?.displayId}</span>
                        </div>
                        <div>
                            <p>Type:</p>
                            <TypeRow text={txn?.type} />
                        </div>
                        <div>
                            <p>Amount:</p>
                            <PriceRow info={txn?.amount} />
                        </div>
                    </div>
                }
                afterSuccess={close}
                required={false}
                innerText={'Void Transaction'}
                inputLabel={'Void Reason (optional)'}
                actionType={VOID_TYPE}
            />
        );

    };

    return (
        <div>
            <FullTable
                head={invoiceTxnTableHead}
                body={invoiceTxnTableBody(handleVoid)}
                loadingType={INVOICE_TXN_LOAD_TYPE}
                list={invoiceTxns}
                noText={'Transactions'}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
